import React from 'react';

import styles from 'styles/components/gigs/GigDetails.module.scss';

const padding = {
  padding: '20px 15px',
  backgroundColor: '#fff',
  borderTop: '1px solid #e0e0e0',
};

const GigDetails = ({ gig }) => (
  <>
    {gig.public && (
      <div style={padding}>
        <h3 className={styles.heading}>Influencers can apply from</h3>

        <p>{gig.us_only ? 'US' : 'Worldwide'}</p>
      </div>
    )}

    {gig.influencer_gender && (
      <div style={padding}>
        <h3 className={styles.heading}>Sexual orientation preferred</h3>

        <p>
          An Influencer who is a{' '}
          <span style={{ fontFamily: 'Avenir Heavy' }}>{gig.influencer_gender.toLowerCase()}</span>{' '}
          will have precedence
        </p>
      </div>
    )}

    {gig.adult_model && (
      <div style={padding}>
        <h3 className={styles.heading}>Adult model preferred</h3>

        <p>This advertiser is open to working with adult models</p>
      </div>
    )}
  </>
);

export default GigDetails;
